module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_7.54c6b475.png";